"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ArrowDownIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "17",
  height: "19",
  viewBox: "0 0 17 19",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-82.000000, -236.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(84.000000, 238.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.625000, -1.500000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(8.125000, 9.000000) rotate(180.000000) translate(-8.125000, -9.000000) translate(0.000000, 0.000000)",
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M9.75,5.08848643 L9.75,16.5 C9.75,17.3284271 9.02246272,18 8.125,18 C7.29164176,18 6.60480086,17.4209397 6.51093256,16.6749317 L6.5,16.5 L6.5,5.1052517 L2.75816555,8.46649774 C2.16439237,8.99974939 1.24211016,9.02965895 0.611501749,8.56408639 L0.460285087,8.43737526 C-0.117404194,7.88927693 -0.149806218,7.03793951 0.354564051,6.45583944 L0.491834446,6.31625483 L7.0518541,0.424878542 C7.64181407,-0.104948555 8.55700057,-0.138330803 9.18792825,0.31956495 L9.3393854,0.444270856 L15.7793657,6.44427086 C16.4110174,7.03276802 16.4062452,7.98250528 15.7687066,8.56556838 C15.1802094,9.10378048 14.2582599,9.14142789 13.6230925,8.68116615 L13.4706343,8.55572914 L9.75,5.08848643 Z"
            })
          })
        })
      })
    })
  })]
});

ArrowDownIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ArrowDownIcon;
exports.default = _default;